/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Flow Do API
 * API таск-менеджера Flow Do. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateInputBody,
  CreateInviteInputBody,
  CreateInviteOutputBody,
  ErrorModel,
  ListOutputBody,
  MemberBody,
  MembersOutputBody,
  RenameInputBody,
  SetRoleInputBody,
  WorkspaceBody
} from '../model';

import { apiFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type workspacesListResponse200 = {
  data: ListOutputBody
  status: 200
}

export type workspacesListResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type workspacesListResponseSuccess = (workspacesListResponse200) & {
  headers: Headers;
};
export type workspacesListResponseError = (workspacesListResponseDefault) & {
  headers: Headers;
};

export type workspacesListResponse = (workspacesListResponseSuccess | workspacesListResponseError)

export const getWorkspacesListUrl = () => {




  return `/workspaces`
}

/**
 * Пространства, в которых состоит текущий пользователь, с его ролью. Владелец платформы видит все.
 * @summary Мои пространства
 */
export const workspacesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<workspacesListResponse> => {

  return apiFetch<workspacesListResponse>(getWorkspacesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspacesListQueryKey = () => {
    return [
    `/workspaces`
    ] as const;
    }


export const getWorkspacesListQueryOptions = <TData = Awaited<ReturnType<typeof workspacesList>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspacesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesList>>> = ({ signal }) => workspacesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspacesListQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesList>>>
export type WorkspacesListQueryError = ErrorModel


export function useWorkspacesList<TData = Awaited<ReturnType<typeof workspacesList>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesList>>,
          TError,
          Awaited<ReturnType<typeof workspacesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesList<TData = Awaited<ReturnType<typeof workspacesList>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesList>>,
          TError,
          Awaited<ReturnType<typeof workspacesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesList<TData = Awaited<ReturnType<typeof workspacesList>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Мои пространства
 */

export function useWorkspacesList<TData = Awaited<ReturnType<typeof workspacesList>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspacesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workspacesCreateResponse201 = {
  data: WorkspaceBody
  status: 201
}

export type workspacesCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type workspacesCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type workspacesCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type workspacesCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type workspacesCreateResponseSuccess = (workspacesCreateResponse201) & {
  headers: Headers;
};
export type workspacesCreateResponseError = (workspacesCreateResponse403 | workspacesCreateResponse409 | workspacesCreateResponse422 | workspacesCreateResponse500) & {
  headers: Headers;
};

export type workspacesCreateResponse = (workspacesCreateResponseSuccess | workspacesCreateResponseError)

export const getWorkspacesCreateUrl = () => {




  return `/workspaces`
}

/**
 * Пока регистрация закрытая, заводить организации может только владелец платформы. Создавший становится владельцем пространства.
 * @summary Создать пространство
 */
export const workspacesCreate = async (createInputBody: NonReadonly<CreateInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<workspacesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<workspacesCreateResponse>(getWorkspacesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInputBody)
  }
);}





export const getWorkspacesCreateQueryKey = (createInputBody?: NonReadonly<CreateInputBody>,) => {
    return [
    'POST', `/workspaces`, createInputBody
    ] as const;
    }


export const getWorkspacesCreateQueryOptions = <TData = Awaited<ReturnType<typeof workspacesCreate>>, TError = ErrorModel>(createInputBody: NonReadonly<CreateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspacesCreateQueryKey(createInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesCreate>>> = ({ signal }) => workspacesCreate(createInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspacesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspacesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesCreate>>>
export type WorkspacesCreateQueryError = ErrorModel


export function useWorkspacesCreate<TData = Awaited<ReturnType<typeof workspacesCreate>>, TError = ErrorModel>(
 createInputBody: NonReadonly<CreateInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesCreate>>,
          TError,
          Awaited<ReturnType<typeof workspacesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesCreate<TData = Awaited<ReturnType<typeof workspacesCreate>>, TError = ErrorModel>(
 createInputBody: NonReadonly<CreateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesCreate>>,
          TError,
          Awaited<ReturnType<typeof workspacesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesCreate<TData = Awaited<ReturnType<typeof workspacesCreate>>, TError = ErrorModel>(
 createInputBody: NonReadonly<CreateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Создать пространство
 */

export function useWorkspacesCreate<TData = Awaited<ReturnType<typeof workspacesCreate>>, TError = ErrorModel>(
 createInputBody: NonReadonly<CreateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspacesCreateQueryOptions(createInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workspacesGetResponse200 = {
  data: WorkspaceBody
  status: 200
}

export type workspacesGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type workspacesGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type workspacesGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type workspacesGetResponseSuccess = (workspacesGetResponse200) & {
  headers: Headers;
};
export type workspacesGetResponseError = (workspacesGetResponse404 | workspacesGetResponse422 | workspacesGetResponse500) & {
  headers: Headers;
};

export type workspacesGetResponse = (workspacesGetResponseSuccess | workspacesGetResponseError)

export const getWorkspacesGetUrl = (slug: string,) => {




  return `/workspaces/${slug}`
}

/**
 * @summary Пространство
 */
export const workspacesGet = async (slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<workspacesGetResponse> => {

  return apiFetch<workspacesGetResponse>(getWorkspacesGetUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspacesGetQueryKey = (slug: string,) => {
    return [
    `/workspaces/${slug}`
    ] as const;
    }


export const getWorkspacesGetQueryOptions = <TData = Awaited<ReturnType<typeof workspacesGet>>, TError = ErrorModel>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspacesGetQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesGet>>> = ({ signal }) => workspacesGet(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspacesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspacesGetQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesGet>>>
export type WorkspacesGetQueryError = ErrorModel


export function useWorkspacesGet<TData = Awaited<ReturnType<typeof workspacesGet>>, TError = ErrorModel>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesGet>>,
          TError,
          Awaited<ReturnType<typeof workspacesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesGet<TData = Awaited<ReturnType<typeof workspacesGet>>, TError = ErrorModel>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesGet>>,
          TError,
          Awaited<ReturnType<typeof workspacesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesGet<TData = Awaited<ReturnType<typeof workspacesGet>>, TError = ErrorModel>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Пространство
 */

export function useWorkspacesGet<TData = Awaited<ReturnType<typeof workspacesGet>>, TError = ErrorModel>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspacesGetQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workspacesRenameResponse200 = {
  data: WorkspaceBody
  status: 200
}

export type workspacesRenameResponse403 = {
  data: ErrorModel
  status: 403
}

export type workspacesRenameResponse404 = {
  data: ErrorModel
  status: 404
}

export type workspacesRenameResponse422 = {
  data: ErrorModel
  status: 422
}

export type workspacesRenameResponse500 = {
  data: ErrorModel
  status: 500
}

export type workspacesRenameResponseSuccess = (workspacesRenameResponse200) & {
  headers: Headers;
};
export type workspacesRenameResponseError = (workspacesRenameResponse403 | workspacesRenameResponse404 | workspacesRenameResponse422 | workspacesRenameResponse500) & {
  headers: Headers;
};

export type workspacesRenameResponse = (workspacesRenameResponseSuccess | workspacesRenameResponseError)

export const getWorkspacesRenameUrl = (slug: string,) => {




  return `/workspaces/${slug}`
}

/**
 * @summary Переименовать пространство
 */
export const workspacesRename = async (slug: string,
    renameInputBody: NonReadonly<RenameInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<workspacesRenameResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<workspacesRenameResponse>(getWorkspacesRenameUrl(slug),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(renameInputBody)
  }
);}





export const getWorkspacesRenameQueryKey = (slug: string,
    renameInputBody?: NonReadonly<RenameInputBody>,) => {
    return [
    'PATCH', `/workspaces/${slug}`, renameInputBody
    ] as const;
    }


export const getWorkspacesRenameQueryOptions = <TData = Awaited<ReturnType<typeof workspacesRename>>, TError = ErrorModel>(slug: string,
    renameInputBody: NonReadonly<RenameInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRename>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspacesRenameQueryKey(slug,renameInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesRename>>> = ({ signal }) => workspacesRename(slug,renameInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspacesRename>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspacesRenameQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesRename>>>
export type WorkspacesRenameQueryError = ErrorModel


export function useWorkspacesRename<TData = Awaited<ReturnType<typeof workspacesRename>>, TError = ErrorModel>(
 slug: string,
    renameInputBody: NonReadonly<RenameInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRename>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesRename>>,
          TError,
          Awaited<ReturnType<typeof workspacesRename>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesRename<TData = Awaited<ReturnType<typeof workspacesRename>>, TError = ErrorModel>(
 slug: string,
    renameInputBody: NonReadonly<RenameInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRename>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesRename>>,
          TError,
          Awaited<ReturnType<typeof workspacesRename>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesRename<TData = Awaited<ReturnType<typeof workspacesRename>>, TError = ErrorModel>(
 slug: string,
    renameInputBody: NonReadonly<RenameInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRename>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Переименовать пространство
 */

export function useWorkspacesRename<TData = Awaited<ReturnType<typeof workspacesRename>>, TError = ErrorModel>(
 slug: string,
    renameInputBody: NonReadonly<RenameInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesRename>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspacesRenameQueryOptions(slug,renameInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workspaceInviteCreateResponse201 = {
  data: CreateInviteOutputBody
  status: 201
}

export type workspaceInviteCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type workspaceInviteCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type workspaceInviteCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type workspaceInviteCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type workspaceInviteCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type workspaceInviteCreateResponseSuccess = (workspaceInviteCreateResponse201) & {
  headers: Headers;
};
export type workspaceInviteCreateResponseError = (workspaceInviteCreateResponse403 | workspaceInviteCreateResponse404 | workspaceInviteCreateResponse409 | workspaceInviteCreateResponse422 | workspaceInviteCreateResponse500) & {
  headers: Headers;
};

export type workspaceInviteCreateResponse = (workspaceInviteCreateResponseSuccess | workspaceInviteCreateResponseError)

export const getWorkspaceInviteCreateUrl = (slug: string,) => {




  return `/workspaces/${slug}/invites`
}

/**
 * Ссылка отдаётся один раз в ответе и передаётся человеку вручную. Повторное приглашение того же адреса отзывает прежнюю ссылку.
 * @summary Пригласить по адресу
 */
export const workspaceInviteCreate = async (slug: string,
    createInviteInputBody: NonReadonly<CreateInviteInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<workspaceInviteCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<workspaceInviteCreateResponse>(getWorkspaceInviteCreateUrl(slug),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInviteInputBody)
  }
);}





export const getWorkspaceInviteCreateQueryKey = (slug: string,
    createInviteInputBody?: NonReadonly<CreateInviteInputBody>,) => {
    return [
    'POST', `/workspaces/${slug}/invites`, createInviteInputBody
    ] as const;
    }


export const getWorkspaceInviteCreateQueryOptions = <TData = Awaited<ReturnType<typeof workspaceInviteCreate>>, TError = ErrorModel>(slug: string,
    createInviteInputBody: NonReadonly<CreateInviteInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceInviteCreateQueryKey(slug,createInviteInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceInviteCreate>>> = ({ signal }) => workspaceInviteCreate(slug,createInviteInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceInviteCreateQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceInviteCreate>>>
export type WorkspaceInviteCreateQueryError = ErrorModel


export function useWorkspaceInviteCreate<TData = Awaited<ReturnType<typeof workspaceInviteCreate>>, TError = ErrorModel>(
 slug: string,
    createInviteInputBody: NonReadonly<CreateInviteInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceInviteCreate>>,
          TError,
          Awaited<ReturnType<typeof workspaceInviteCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceInviteCreate<TData = Awaited<ReturnType<typeof workspaceInviteCreate>>, TError = ErrorModel>(
 slug: string,
    createInviteInputBody: NonReadonly<CreateInviteInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceInviteCreate>>,
          TError,
          Awaited<ReturnType<typeof workspaceInviteCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceInviteCreate<TData = Awaited<ReturnType<typeof workspaceInviteCreate>>, TError = ErrorModel>(
 slug: string,
    createInviteInputBody: NonReadonly<CreateInviteInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Пригласить по адресу
 */

export function useWorkspaceInviteCreate<TData = Awaited<ReturnType<typeof workspaceInviteCreate>>, TError = ErrorModel>(
 slug: string,
    createInviteInputBody: NonReadonly<CreateInviteInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceInviteCreateQueryOptions(slug,createInviteInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workspaceInviteRevokeResponse204 = {
  data: void
  status: 204
}

export type workspaceInviteRevokeResponse403 = {
  data: ErrorModel
  status: 403
}

export type workspaceInviteRevokeResponse404 = {
  data: ErrorModel
  status: 404
}

export type workspaceInviteRevokeResponse422 = {
  data: ErrorModel
  status: 422
}

export type workspaceInviteRevokeResponse500 = {
  data: ErrorModel
  status: 500
}

export type workspaceInviteRevokeResponseSuccess = (workspaceInviteRevokeResponse204) & {
  headers: Headers;
};
export type workspaceInviteRevokeResponseError = (workspaceInviteRevokeResponse403 | workspaceInviteRevokeResponse404 | workspaceInviteRevokeResponse422 | workspaceInviteRevokeResponse500) & {
  headers: Headers;
};

export type workspaceInviteRevokeResponse = (workspaceInviteRevokeResponseSuccess | workspaceInviteRevokeResponseError)

export const getWorkspaceInviteRevokeUrl = (slug: string,
    inviteId: string,) => {




  return `/workspaces/${slug}/invites/${inviteId}`
}

/**
 * @summary Отозвать приглашение
 */
export const workspaceInviteRevoke = async (slug: string,
    inviteId: string, options?: Parameters<typeof apiFetch>[1]): Promise<workspaceInviteRevokeResponse> => {

  return apiFetch<workspaceInviteRevokeResponse>(getWorkspaceInviteRevokeUrl(slug,inviteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getWorkspaceInviteRevokeQueryKey = (slug: string,
    inviteId: string,) => {
    return [
    'DELETE', `/workspaces/${slug}/invites/${inviteId}`
    ] as const;
    }


export const getWorkspaceInviteRevokeQueryOptions = <TData = Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError = ErrorModel>(slug: string,
    inviteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceInviteRevokeQueryKey(slug,inviteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceInviteRevoke>>> = ({ signal }) => workspaceInviteRevoke(slug,inviteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined && inviteId !== null && inviteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceInviteRevokeQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceInviteRevoke>>>
export type WorkspaceInviteRevokeQueryError = ErrorModel


export function useWorkspaceInviteRevoke<TData = Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError = ErrorModel>(
 slug: string,
    inviteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceInviteRevoke>>,
          TError,
          Awaited<ReturnType<typeof workspaceInviteRevoke>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceInviteRevoke<TData = Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError = ErrorModel>(
 slug: string,
    inviteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceInviteRevoke>>,
          TError,
          Awaited<ReturnType<typeof workspaceInviteRevoke>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceInviteRevoke<TData = Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError = ErrorModel>(
 slug: string,
    inviteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отозвать приглашение
 */

export function useWorkspaceInviteRevoke<TData = Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError = ErrorModel>(
 slug: string,
    inviteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceInviteRevoke>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceInviteRevokeQueryOptions(slug,inviteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workspaceMembersListResponse200 = {
  data: MembersOutputBody
  status: 200
}

export type workspaceMembersListResponse404 = {
  data: ErrorModel
  status: 404
}

export type workspaceMembersListResponse422 = {
  data: ErrorModel
  status: 422
}

export type workspaceMembersListResponse500 = {
  data: ErrorModel
  status: 500
}

export type workspaceMembersListResponseSuccess = (workspaceMembersListResponse200) & {
  headers: Headers;
};
export type workspaceMembersListResponseError = (workspaceMembersListResponse404 | workspaceMembersListResponse422 | workspaceMembersListResponse500) & {
  headers: Headers;
};

export type workspaceMembersListResponse = (workspaceMembersListResponseSuccess | workspaceMembersListResponseError)

export const getWorkspaceMembersListUrl = (slug: string,) => {




  return `/workspaces/${slug}/members`
}

/**
 * @summary Участники и приглашения
 */
export const workspaceMembersList = async (slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<workspaceMembersListResponse> => {

  return apiFetch<workspaceMembersListResponse>(getWorkspaceMembersListUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspaceMembersListQueryKey = (slug: string,) => {
    return [
    `/workspaces/${slug}/members`
    ] as const;
    }


export const getWorkspaceMembersListQueryOptions = <TData = Awaited<ReturnType<typeof workspaceMembersList>>, TError = ErrorModel>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceMembersListQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceMembersList>>> = ({ signal }) => workspaceMembersList(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceMembersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceMembersListQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceMembersList>>>
export type WorkspaceMembersListQueryError = ErrorModel


export function useWorkspaceMembersList<TData = Awaited<ReturnType<typeof workspaceMembersList>>, TError = ErrorModel>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMembersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceMembersList>>,
          TError,
          Awaited<ReturnType<typeof workspaceMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceMembersList<TData = Awaited<ReturnType<typeof workspaceMembersList>>, TError = ErrorModel>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMembersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceMembersList>>,
          TError,
          Awaited<ReturnType<typeof workspaceMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceMembersList<TData = Awaited<ReturnType<typeof workspaceMembersList>>, TError = ErrorModel>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Участники и приглашения
 */

export function useWorkspaceMembersList<TData = Awaited<ReturnType<typeof workspaceMembersList>>, TError = ErrorModel>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceMembersListQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workspaceMemberRemoveResponse204 = {
  data: void
  status: 204
}

export type workspaceMemberRemoveResponse403 = {
  data: ErrorModel
  status: 403
}

export type workspaceMemberRemoveResponse404 = {
  data: ErrorModel
  status: 404
}

export type workspaceMemberRemoveResponse409 = {
  data: ErrorModel
  status: 409
}

export type workspaceMemberRemoveResponse422 = {
  data: ErrorModel
  status: 422
}

export type workspaceMemberRemoveResponse500 = {
  data: ErrorModel
  status: 500
}

export type workspaceMemberRemoveResponseSuccess = (workspaceMemberRemoveResponse204) & {
  headers: Headers;
};
export type workspaceMemberRemoveResponseError = (workspaceMemberRemoveResponse403 | workspaceMemberRemoveResponse404 | workspaceMemberRemoveResponse409 | workspaceMemberRemoveResponse422 | workspaceMemberRemoveResponse500) & {
  headers: Headers;
};

export type workspaceMemberRemoveResponse = (workspaceMemberRemoveResponseSuccess | workspaceMemberRemoveResponseError)

export const getWorkspaceMemberRemoveUrl = (slug: string,
    userId: string,) => {




  return `/workspaces/${slug}/members/${userId}`
}

/**
 * Владельца может исключить только владелец. Последнего владельца — никто.
 * @summary Исключить участника
 */
export const workspaceMemberRemove = async (slug: string,
    userId: string, options?: Parameters<typeof apiFetch>[1]): Promise<workspaceMemberRemoveResponse> => {

  return apiFetch<workspaceMemberRemoveResponse>(getWorkspaceMemberRemoveUrl(slug,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getWorkspaceMemberRemoveQueryKey = (slug: string,
    userId: string,) => {
    return [
    'DELETE', `/workspaces/${slug}/members/${userId}`
    ] as const;
    }


export const getWorkspaceMemberRemoveQueryOptions = <TData = Awaited<ReturnType<typeof workspaceMemberRemove>>, TError = ErrorModel>(slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberRemove>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceMemberRemoveQueryKey(slug,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceMemberRemove>>> = ({ signal }) => workspaceMemberRemove(slug,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberRemove>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceMemberRemoveQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceMemberRemove>>>
export type WorkspaceMemberRemoveQueryError = ErrorModel


export function useWorkspaceMemberRemove<TData = Awaited<ReturnType<typeof workspaceMemberRemove>>, TError = ErrorModel>(
 slug: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberRemove>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceMemberRemove>>,
          TError,
          Awaited<ReturnType<typeof workspaceMemberRemove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceMemberRemove<TData = Awaited<ReturnType<typeof workspaceMemberRemove>>, TError = ErrorModel>(
 slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberRemove>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceMemberRemove>>,
          TError,
          Awaited<ReturnType<typeof workspaceMemberRemove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceMemberRemove<TData = Awaited<ReturnType<typeof workspaceMemberRemove>>, TError = ErrorModel>(
 slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberRemove>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Исключить участника
 */

export function useWorkspaceMemberRemove<TData = Awaited<ReturnType<typeof workspaceMemberRemove>>, TError = ErrorModel>(
 slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberRemove>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceMemberRemoveQueryOptions(slug,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workspaceMemberSetRoleResponse200 = {
  data: MemberBody
  status: 200
}

export type workspaceMemberSetRoleResponse403 = {
  data: ErrorModel
  status: 403
}

export type workspaceMemberSetRoleResponse404 = {
  data: ErrorModel
  status: 404
}

export type workspaceMemberSetRoleResponse409 = {
  data: ErrorModel
  status: 409
}

export type workspaceMemberSetRoleResponse422 = {
  data: ErrorModel
  status: 422
}

export type workspaceMemberSetRoleResponse500 = {
  data: ErrorModel
  status: 500
}

export type workspaceMemberSetRoleResponseSuccess = (workspaceMemberSetRoleResponse200) & {
  headers: Headers;
};
export type workspaceMemberSetRoleResponseError = (workspaceMemberSetRoleResponse403 | workspaceMemberSetRoleResponse404 | workspaceMemberSetRoleResponse409 | workspaceMemberSetRoleResponse422 | workspaceMemberSetRoleResponse500) & {
  headers: Headers;
};

export type workspaceMemberSetRoleResponse = (workspaceMemberSetRoleResponseSuccess | workspaceMemberSetRoleResponseError)

export const getWorkspaceMemberSetRoleUrl = (slug: string,
    userId: string,) => {




  return `/workspaces/${slug}/members/${userId}`
}

/**
 * Владельца назначает и снимает только владелец. Последнего владельца снять нельзя.
 * @summary Сменить роль участника
 */
export const workspaceMemberSetRole = async (slug: string,
    userId: string,
    setRoleInputBody: NonReadonly<SetRoleInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<workspaceMemberSetRoleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<workspaceMemberSetRoleResponse>(getWorkspaceMemberSetRoleUrl(slug,userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setRoleInputBody)
  }
);}





export const getWorkspaceMemberSetRoleQueryKey = (slug: string,
    userId: string,
    setRoleInputBody?: NonReadonly<SetRoleInputBody>,) => {
    return [
    'PATCH', `/workspaces/${slug}/members/${userId}`, setRoleInputBody
    ] as const;
    }


export const getWorkspaceMemberSetRoleQueryOptions = <TData = Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError = ErrorModel>(slug: string,
    userId: string,
    setRoleInputBody: NonReadonly<SetRoleInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceMemberSetRoleQueryKey(slug,userId,setRoleInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceMemberSetRole>>> = ({ signal }) => workspaceMemberSetRole(slug,userId,setRoleInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceMemberSetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceMemberSetRole>>>
export type WorkspaceMemberSetRoleQueryError = ErrorModel


export function useWorkspaceMemberSetRole<TData = Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError = ErrorModel>(
 slug: string,
    userId: string,
    setRoleInputBody: NonReadonly<SetRoleInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceMemberSetRole>>,
          TError,
          Awaited<ReturnType<typeof workspaceMemberSetRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceMemberSetRole<TData = Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError = ErrorModel>(
 slug: string,
    userId: string,
    setRoleInputBody: NonReadonly<SetRoleInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceMemberSetRole>>,
          TError,
          Awaited<ReturnType<typeof workspaceMemberSetRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceMemberSetRole<TData = Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError = ErrorModel>(
 slug: string,
    userId: string,
    setRoleInputBody: NonReadonly<SetRoleInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сменить роль участника
 */

export function useWorkspaceMemberSetRole<TData = Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError = ErrorModel>(
 slug: string,
    userId: string,
    setRoleInputBody: NonReadonly<SetRoleInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceMemberSetRole>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceMemberSetRoleQueryOptions(slug,userId,setRoleInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






